import React, { useState } from 'react';
import { get, post } from '../../Services/http';
import { translate } from '../../Services/translation';

const InventoryEditAddProductPopup = (props) => {

    const [articleNumber, setArticleNumber] = useState("");
    const [isProductAvailable, setIsProductAvailable] = useState(false);
    const [productToAdd, setProductToAdd] = useState();
    const [quantityToAdd, setQuantityToAdd] = useState(0);
    const [unknownArticleNumber, setUnknownArticleNumber] = useState(false);
    const [productAlreadyInStock, setProductAlreadyInStock] = useState(false);

    const checkItem = () => {
        get(`/api/inventoryedit/checkitem/${articleNumber}`)
        .then((response) => response.json())
        .then((result) => {
            if (result.id !== null) {
                setProductToAdd(result);
                setProductAlreadyInStock(result.quantityInStock > 0);
                setQuantityToAdd(result.quantityInStock);
                setIsProductAvailable(result.isClickAndCollect);
            } else {
                setUnknownArticleNumber(true)
            }
        })
    }

    const addItem = () => {
        post('/api/inventoryedit/additem?variantId=' + articleNumber + '&quantityToAdd=' + quantityToAdd)
        .then(response => response.json())
        .then(result => {
            props.setProducts(result);
        })
    }

    return (
        <>
            {!productToAdd && !unknownArticleNumber && (
                <>
                    <h3>{translate('brenderup.inventoryedit.addproducttitle')}</h3>
                    <input 
                        type='text'
                        onChange={(event) => {
                            setArticleNumber(event.target.value);
                        }}
                    />
                    <button onClick={() => checkItem()}>{translate('brenderup.inventoryedit.addproductbutton')}</button>
                </>
            )}

            {productToAdd && (
                <>
                    {isProductAvailable ? (
                        <>
                            { productAlreadyInStock ? (
                                <div className='add-warning'>
                                    <h3>{translate('brenderup.inventoryedit.alreadyinstocktitle')}</h3>
                                    <p>{translate('brenderup.inventoryedit.alreadyinstocktext')}</p>
                                    <div className='add-warning__button-wrapper'>
                                        <button onClick={() => props.setOpen(false)}>{translate('brenderup.inventoryedit.alreadyinstockcancel')}</button>
                                        <button onClick={() => setProductAlreadyInStock(false)}>{translate('brenderup.inventoryedit.alreadyinstockcontinue')}</button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <h3>{translate('brenderup.inventoryedit.confirmproducttitle')}</h3>
                                    <div className='product-row'>
                                        <div className="image" dangerouslySetInnerHTML={{ __html: productToAdd.imageUrl }}></div>
                                        <p className='name'>{productToAdd.name}</p>
                                        <p className='art-nr'>{productToAdd.id}</p>
                                    </div>
                                    <div className='edit-row'>
                                        <label htmlFor="stockInput">
                                            {translate('brenderup.inventoryedit.enterstockquantity')}
                                        </label>
                                        <input 
                                            type="number" 
                                            id="stockInput"
                                            value={quantityToAdd}
                                            onChange={(event) => setQuantityToAdd(event.target.value)}
                                        />
                                        <button onClick={() => {
                                            addItem();
                                            props.setOpen(false);
                                        }}>
                                            {translate('brenderup.inventoryedit.confirmproductbutton')}
                                        </button>
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <h3>{translate('brenderup.inventoryedit.errortitle')}</h3>
                            <p>{translate('brenderup.inventoryedit.notavailable')}</p>
                        </>
                    )}
                </>
            )}

            {unknownArticleNumber && (
                <>
                    <h3>{translate('brenderup.inventoryedit.errortitle')}</h3>
                    <p>{translate('brenderup.inventoryedit.noproduct')}</p>
                </>
            )}
        </>
    )
}

export default InventoryEditAddProductPopup;